import styled from 'styled-components';

type Props = {
  readonly children: JSX.Element | JSX.Element[];
  readonly element?: 'span' | 'legend';
  readonly id?: string;
  readonly ariaLive?: 'polite' | 'assertive' | 'off';
};
// Content will be visually hidden, but read by screen readers
// https://www.scottohara.me/blog/2017/04/14/inclusively-hidden.html
const hidden = `
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
const Legend = styled.legend`
  ${hidden}
`;
const Span = styled.span`
  ${hidden}
`;

/**
 * Using span here should cover most of our usecases
 * The legend field should be used when we are using the fieldset to group elements in a form. See ChoiceTiles as an example.
 * In the future, we could add more elements if needed.
 */

const InclusivelyHidden = ({ children, id, element = 'span', ariaLive }: Props): JSX.Element => {
  let Element;

  switch (element) {
    case 'legend':
      Element = Legend;
      break;

    default:
      Element = Span;
      break;
  }

  return (
    <Element aria-live={ariaLive} id={id}>
      {children}
    </Element>
  );
};

export default InclusivelyHidden;
